export const getObjectTypeString = (obj: any) => Object.prototype.toString.call(obj)

export const isString = (obj: any) => getObjectTypeString(obj) === '[object String]'

export const isObject = (obj: any) => getObjectTypeString(obj) === '[object Object]'

export const isFunction = (obj: any) => {
  let str = getObjectTypeString(obj)
  return str === '[object Function]' || str === '[object AsyncFunction]'
}

export const isArray = (obj: any) => getObjectTypeString(obj) === '[object Array]'

export const isSet = (obj: any) => getObjectTypeString(obj) === '[object Set]'

export const isMap = (obj: any) => getObjectTypeString(obj) === '[object Map]'

export const isEmpty = (value: any) => {
  if (isArray(value) && value.length === 0) return true

  return value === '' || value === undefined || value === null
}

// 校验邮箱
export const isEmail = (email: string) => {
  const reg = new RegExp(/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/)
  return reg.test(email)
}


/**
 * 深度复制对象
 * @param obj - 任意对象
 */
export const deepClone = (obj: any) => {
  let map = new WeakMap()

  let clone = (obj: any) => {
    if (typeof obj !== 'object' || obj === null) {
      return obj
    }

    if (obj.constructor === Date) {
      return new Date(obj)
    }

    if (obj.constructor === RegExp) {
      return new RegExp(obj)
    }


    let prototype = Object.getPrototypeOf(obj)
    let descriptors = Object.getOwnPropertyDescriptors(obj)
    let object = Object.create(prototype, descriptors)
    map.set(obj, object)

    Reflect.ownKeys(obj).forEach(key => {
      if (typeof obj[key] !== 'object' || obj[key] === null) {
        object[key] = obj[key]
      } else {
        let mapValue = map.get(obj[key])
        if (mapValue) {
          object[key] = mapValue
        } else {
          object[key] = clone(obj[key])
        }
      }
    })
    return object
  }

  return clone(obj)
}

// 将对象中所有 Key 的值转成数组的形式
export const objectToArray = (obj: any) => {
  return Object.keys(obj).map(k => obj[k])
}

// 将表单对象转换成键值对对象
export const formToObject = (form: FormData) => {
  let entries = [...form.entries()]
  let obj: any = {}
  entries.forEach(entry => {
    if (typeof entry[1] === 'string') {
      try {
        obj[entry[0]] = JSON.parse(entry[1])
      } catch(e) {
        obj[entry[0]] = entry[1]
      }
    } else {
      obj[entry[0]] = entry[1]
    }
  })
  return obj
}